import { timeout } from 'd3';
import { useContext, useEffect, useState } from 'react';
import { InterfaceContext } from '../model/InterfaceProvider';
import Modal, { ModalBackground } from './Modal';

const MessageModal = (props) => {
    const { errorMessage, setMessage, message } = useContext(InterfaceContext);
    const pixelCoords = [0, 0];
    // const [waiting, setWaiting] = useState(false);
    const [messageText, setMessageText] = useState(errorMessage);

    const closeWindow = () => {
        // setWaiting(false);
        setMessage('');
    };
    useEffect(() => {
        if (message) {
            setMessageText(message);
            setTimeout(() => {
                closeWindow();
            }, 5000);  
        }
    }, [message]);

    const vis = message && message !== 'hide' ? 'show' : '';
    const visClass = message && message !== 'hide' ? 'show' : '';

    return (
        <>
            <div id={`message-window`} className={` ${message} info-box-pop ${visClass}`}>
                <Modal pixelCoords={pixelCoords} visible={vis} title={'Alert'} pinned={message} onClose={closeWindow}>
                    <div className="mid-bar">{message}</div>
                    <div className={'error-details'} style={{ display: 'none' }}></div>
                </Modal>
            </div>
        </>
    );
};
export default MessageModal;

const MessageModalBackground = () => {
    const { message } = useContext(InterfaceContext);
    return <ModalBackground visible={message} />;
};
export { MessageModalBackground };
